$('#menu-toggle-mobile').on('click', function() {
    // Faz o toggle da sua lista (o que você já tinha)
    $('#menu-lista').toggleClass('d-none');
    
    // Faz o toggle dos ícones dentro do botão
    $(this).find('.icon-menu, .icon-close').toggle();
});